import React from "react";

const reasons = [
  {
    icon: "🌟",
    title: "Why Thousands of Students Choose Rankridge Every Year?",
    desc: `At Rankridge Jr. College, we redefine success by producing not just students — but future IITians, doctors, scientists, and leaders.`,
  },
  {
    icon: "🔥",
    title: "India’s Most Respected Faculty from IITs, NITs & AIIMS",
    desc: `Faculty from IITs/AIIMS, 1-on-1 mentoring, concept-based national-level teaching.`,
  },
  {
    icon: "🏆",
    title: "Ranks That Speak for Themselves – Year After Year",
    desc: `Top AIRs, IIT Bombay/Madras, AIIMS Delhi selections, 90%+ Board & EAMCET success.`,
  },
  {
    icon: "🎯",
    title: "Rank-Focused Academic Programs",
    desc: `Integrated Board+Entrance programs, Booster batches, early foundation, revision camps.`,
  },
  {
    icon: "📚",
    title: "Scientifically Designed Study Material",
    desc: `NCERT-aligned RSMs, DPPs, PYQs, flowcharts, digital tests & revision tools.`,
  },
  {
    icon: "🧪",
    title: "Exams that Build Ranks – Daily to Monthly",
    desc: `Micro-assessments, weekly grand tests, AI analytics, national benchmarks.`,
  },
  {
    icon: "🧠",
    title: "Elite Doubt Clarification & Concept Reinforcement",
    desc: `1:1 doubt sessions, concept mapping, visual learning, live demos.`,
  },
  {
    icon: "🤝",
    title: "Unmatched Student Care & Personal Focus",
    desc: `Small batches, daily tracking, motivation & mental fitness support.`,
  },
  {
    icon: "🛡️",
    title: "24x7 Surveillance & Secure Campus Environment",
    desc: `CCTV hostels/classrooms, wardens, gender-separated zones, secure access.`,
  },
  {
    icon: "🧑‍🍳",
    title: "High-Hygiene Nutritious Food & Wellness Support",
    desc: `Hygienic meals, diet plans, fresh fruits, health checkups.`,
  },
  {
    icon: "🕒",
    title: "Disciplined Study Hours & Time-Boxed Routine",
    desc: `Structured schedules, distraction-free halls, time-slotted revisions.`,
  },
  {
    icon: "📊",
    title: "Weekly Reports, Analysis & Parent Engagement",
    desc: `Parent dashboards, strategy meetings, app alerts, real-time performance.`,
  },
  {
    icon: "🚀",
    title: "99% Success Rate – Because Our System Works",
    desc: `Thousands in IITs/AIIMS/NITs. Proven and repeatable success strategy.`,
  },
];

const WhyChooseRankridge = () => {
  return (
    <div className="bg-[#20b2aa] py-12 px-4 sm:px-6 lg:px-16">
      <h1 className="text-3xl md:text-4xl font-bold text-center text-black mb-4">
        Why Choose Rankridge?
      </h1>
      <p className="text-center max-w-3xl mx-auto text-black mb-12 text-lg">
        Rankridge – The Trusted Choice of Toppers, Where India’s Future Doctors & IITians Begin Their Journey,
        and Every Potential is Shaped into a Success Story.
      </p>
      <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {reasons.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-md p-6 hover:shadow-lg transition duration-300"
          >
            <div className="text-4xl mb-4 text-indigo-600">{item.icon}</div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              {item.title}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChooseRankridge;
